import { StyleSheet } from 'react-native';
import { Background } from 'src/theme-v2/background';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { CornerRadius } from 'src/theme-v2/corner-radius';
import { Spacing } from 'src/theme-v2/spacing';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const styles = StyleSheet.create({
  icon: {
    width: 34,
    height: 34,
    borderRadius: CornerRadius.Normal,
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconAction: {
    width: Spacing.Compact,
    height: Spacing.Compact,
  },
  countText: {
    color: ColorTypography.TextColorPrimary,
    minWidth: Spacing.Cozy,
    textAlign: 'center',
    marginHorizontal: Spacing.Micro,
    ...textLatoStyleDS.BodyBoldMd,
  },
  buttonText: {
    color: ColorTypography.TextColorTertiary,
    paddingTop: Spacing.Micro,
    ...textLatoStyleDS.BodyRegularXs,
  },
  buttonsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: CornerRadius.Normal,
  },
  backgroundOnDark: {
    backgroundColor: Background.BackgroundColorDefault,
  },
  backgroundOnLight: {
    backgroundColor: Background.BackgroundColorBrand,
  },
});
